import { arrayToString } from "./humanize.js";

const code = document.querySelector("#code");

export const updateCode = (array, dynamicCode = "\n") => {
  code.innerHTML = `let data = ${arrayToString(array)}\n${dynamicCode}`;
  if (window.Prism) {
    window.Prism.highlightAll();
  }
};
